export enum CategoryGroupName {
  General_Base = 'General_Base',
  General_Shopper = 'General_Shopper',
  General_Purchase = 'General_Purchase',
  General_Product = 'General_Product',
  General_Archive = 'General_Archive',

  ProductReview_Base = 'ProductReview_Base',
  ProductReview_Purchase = 'ProductReview_Purchase',
  ProductReview_Review = 'ProductReview_Review',
}

export interface FilterData {
  variable_id: number
  answer_id: number
  answer_code: number
}

export interface FilterMeta {
  label: string
  desc: string
  categoryGroup: CategoryGroupName
  operator?: string
  categoryName?: string
}

export type Filter = FilterData & FilterMeta

// e.g. Audience Definition
export interface CategoryGroup {
  id: number
  label: CategoryGroupName | string
  categories: Category[]
}

// e.g. Demographics
export interface Category {
  id: number
  label: string
  variables: Variable[]
  subSection?: string
}

// e.g. Age
export interface Variable {
  variable_id: number
  label: string
  values: Answer[]
  categoryGroup?: CategoryGroupName
  tooltip_content?: string
  placeholder?: string
  show_separator_top?: boolean
  show_separator_bottom?: boolean
  disable_on_select?: boolean
}

// e.g. 18-24
export interface Answer {
  answer_id: number
  answer_code: number
  label: string
  category_name?: string
}

export enum Operator {
  NOT_IN = 'not_in',
}

export enum Schema {
  CIE = 'cie',
  CIE_REVIEW = 'cie_review',
}

export interface FooterProps {
  linkText: string
  pageName: string
  toLocation: string
  locationTitle: string
}

export enum Location {
  PRODUCT_REVIEW = '/cie/brand/productReviews',
  PRODUCT_REVIEWS = 'Product Reviews',
  AUDIENCE_PROFILER = '/audience-profiler',
  AUDIENCE_PROFILER_TITLE = 'Audience Profiler',
  STORIES = 'Stories',
  OVERVIEW = 'Overview',
  TABLE_OF_CONTENTS = 'Table of Contents',
  NPS_SHOPPERS = '/cie/stories/nps-with-shopper-voices',
}

export enum SubCategories {
  General = 'General',
  Features = 'Features',
}
export interface RowSpec {
  header: {
    hint?: string
    title: string
    secondaryTitle: string
  }
  hide?: {
    codes: number[]
  }
}

export enum CategoryLabels {
  Product = 'Product Specification',
}

export const TIME_FRAME = 'Time Frame: '
